import { computed, makeObservable } from "mobx";
import { createModelSchema, optional, primitive } from "serializr";

export const issueReasons = {
  customer_unreachable: 'Customer unreachable',
  location_difficulty: 'Location difficulty',
  restaurant_delay: 'Restaurant delay',
  misc: 'Other issue',
  failed_id_check: 'Failed ID check',
  no_issue: 'Resolved'
};

export class JobIssue {
  id: number | null = null;
  created: number | null = null;

  type: keyof typeof issueReasons | null = null;

  constructor() {
    makeObservable(this, {
      description: computed
    });
  }

  get description(): string {
    return this.type ? issueReasons[this.type] || '' : '';
  }
}

createModelSchema(JobIssue, {
  id: optional(primitive()),
  created: optional(primitive()),
  type: optional(primitive())
});
